import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '../typography/Typography';
import { CustomOuterLink, IconWrapper } from './styles';
const SocialOuterLink = ({ url, Icon, title, className, }) => {
    return (_jsxs(CustomOuterLink, { to: url, className: className, children: [_jsx(IconWrapper, { children: Icon }), _jsx(Typography, { fontFamily: "primaryBold", type: "bodyButton", children: title })] }));
};
export default SocialOuterLink;
//# sourceMappingURL=SocialOuterLink.js.map